import React, { forwardRef, useState, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Button, Menu, MenuItem } from "@material-ui/core";

import HorizontalAssetList from "../../Shared/AssetPreviewList/HorizontalAssetList";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import CreativeDialog from "../../Shared/AssignedCreativesDialog/CreativeDialog";

import { addCreative } from "../../../actions/app/creatives";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    // border: "1px solid rgba(0, 0, 0, 0.26)",
    boxShadow: "none",
    display: "flex",
    justifyContent: "space-around"
  },
  thumbsContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    width: "100%"
  },
  h6: {
    fontWeight: 400,
    fontSize: "1.15rem"
  }
}));

export default forwardRef(
  ({ isClickEnabled, isDragDisabled, isThumbnailEnabled }, ref) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const placements = useSelector(
      (state) => state.creatives.assignedPlacements
    );
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const [selectedCreatives, setSelectedCreatives] = useState([]);
    const creativeTypes = ["TRACKING_TEXT"];
    const bartCreatives = useSelector((state) => state.creatives);

    let defaultTrackingCreative = {};

    if (placements[0])
      defaultTrackingCreative.taxonomy = {
        dimensions: `${placements[0].size.width}x${placements[0].size.height}`
      };

    const handleMenuOpen = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
      setAnchorEl(null);
    };

    useImperativeHandle(ref, () => ({
      validate() {
        if (bartCreatives.allIds.length === 0) {
          return {
            hasErrors: true,
            message: "You need to add at least one creative."
          };
        }

        return {
          hasErrors: false,
          message: ""
        };
      }
    }));

    return (
      <React.Fragment>
        <Typography variant="h6" className={classes.h6}>
          Insert new or select from existing site-served creative(s) below
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <HorizontalAssetList
              simplifyCardContent={true}
              isClickEnabled={isClickEnabled}
              isDragDisabled={isDragDisabled}
              isThumbnailEnabled={isThumbnailEnabled}
            />
          </Grid>
          <Grid
            item
            xs={6}
            container
            direction="row"
            justify="space-around"
            alignItems="flex-start"
          >
            <Button
              color="secondary"
              variant="contained"
              disableElevation
              endIcon={<ArrowDropDownIcon />}
              onClick={handleMenuOpen}
            >
              Add tracking creative
            </Button>
            <Menu
              id="site-served-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleCloseMenu}
              transformOrigin={{
                vertical: -45,
                horizontal: "left"
              }}
            >
              <MenuItem
                onClick={() => {
                  setAnchorEl(null);
                  dispatch(addCreative(defaultTrackingCreative));
                }}
              >
                Insert new creative
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setAnchorEl(null);
                  setOpen(true);
                }}
              >
                Assign existing creative
              </MenuItem>
            </Menu>
          </Grid>
        </Grid>
        <CreativeDialog
          open={open}
          setOpen={setOpen}
          backup={false}
          creativeTypes={creativeTypes}
          selectedCreatives={selectedCreatives}
          setSelectedCreatives={setSelectedCreatives}
          placements={placements}
        />
      </React.Fragment>
    );
  }
);
